/* Talash × Depot product page behaviour. Loaded by several sections; runs once. */
(function () {
  if (window.__tlDepot) return;
  window.__tlDepot = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    format = format || '£{{amount}}';
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  function addToCart(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to basket.');
        return data;
      });
    });
  }

  function afterAdd(mode) {
    document.dispatchEvent(new CustomEvent('tld:cart-added', { bubbles: true }));
    if (mode !== 'stay') window.location.href = root + 'cart';
  }

  function initGallery(g) {
    if (g.dataset.tldReady) return;
    g.dataset.tldReady = '1';
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-tld-slide]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-tld-thumb]'));
    var i = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    function show(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (thumbs[i] && thumbs[i].scrollIntoView && g.dataset.tldScroll) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    if (i > 0) show(i);
    g.tldShowMedia = function (mediaId) {
      var k = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
      if (k > -1) show(k);
    };
    var prev = g.querySelector('[data-tld-prev]');
    var next = g.querySelector('[data-tld-next]');
    if (prev) prev.addEventListener('click', function () { g.dataset.tldScroll = '1'; show(i - 1); });
    if (next) next.addEventListener('click', function () { g.dataset.tldScroll = '1'; show(i + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var main = g.querySelector('.tld-gal__main');
    var x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      });
    }
  }

  function initBuybox(bb) {
    if (bb.dataset.tldReady) return;
    bb.dataset.tldReady = '1';
    var fmt = bb.dataset.money;
    var mode = bb.dataset.afterAdd;
    var variantsEl = bb.querySelector('[data-tld-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var form = bb.querySelector('form[data-tld-form]');
    var idInput = bb.querySelector('[data-tld-variant-id]');
    var qtyInput = bb.querySelector('[data-tld-qty]');
    var atc = bb.querySelector('[data-tld-atc]');
    var atcLabel = bb.querySelector('[data-tld-atc-label]');
    var errorEl = bb.querySelector('[data-tld-error]');
    var gallery = bb.querySelector('[data-tld-gallery]');
    var sticky = document.querySelector('[data-tld-sticky]');
    var current = variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function checkedAddons() {
      return Array.prototype.slice.call(bb.querySelectorAll('[data-tld-addon]:checked'));
    }

    function update() {
      if (!current) return;
      var base = current.price * qty();
      var addons = checkedAddons().reduce(function (sum, el) { return sum + parseInt(el.dataset.price, 10); }, 0);
      var total = base + addons;
      bb.querySelectorAll('[data-tld-total]').forEach(function (el) { el.textContent = formatMoney(total, fmt); });
      bb.querySelectorAll('[data-tld-price]').forEach(function (el) { el.textContent = formatMoney(current.price, fmt); });
      bb.querySelectorAll('[data-tld-compare]').forEach(function (el) {
        var on = current.compare_at_price && current.compare_at_price > current.price;
        el.hidden = !on;
        if (on) {
          var was = el.querySelector('[data-tld-was]');
          var save = el.querySelector('[data-tld-save]');
          if (was) was.textContent = formatMoney(current.compare_at_price, fmt);
          if (save) {
            var diff = current.compare_at_price - current.price;
            save.textContent = 'Save ' + formatMoney(diff, fmt) + ' (' + Math.round(diff * 100 / current.compare_at_price) + '%)';
          }
        }
      });
      bb.querySelectorAll('[data-tld-stock]').forEach(function (el) {
        el.classList.toggle('is-out', !current.available);
        if (!current.available) el.textContent = el.dataset.outText || 'Out of stock';
        else el.textContent = el.dataset.inText || 'In stock, ready to ship';
      });
      bb.querySelectorAll('[data-tld-addon]').forEach(function (el) {
        var row = el.closest('.tld-fbt__item');
        if (row) row.classList.toggle('is-checked', el.checked);
      });
      if (atc) atc.disabled = !current.available;
      if (atcLabel) atcLabel.textContent = current.available ? (atcLabel.dataset.label + ' — ' + formatMoney(total, fmt)) : (atcLabel.dataset.soldOut || 'Sold out');
      if (sticky) {
        var sp = sticky.querySelector('[data-tld-sticky-price]');
        if (sp) sp.textContent = formatMoney(total, fmt);
      }
    }

    bb.querySelectorAll('[data-tld-option]').forEach(function (input) {
      input.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(bb.querySelectorAll('[data-tld-option-group]'), function (group) {
          var c = group.querySelector('input:checked');
          return c ? c.value : null;
        });
        var match = variants.find(function (v) { return v.options.every(function (o, k) { return o === chosen[k]; }); });
        if (match) {
          current = match;
          if (idInput) idInput.value = match.id;
          if (match.featured_media && gallery && gallery.tldShowMedia) gallery.tldShowMedia(match.featured_media.id);
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
        update();
      });
    });

    bb.querySelectorAll('[data-tld-addon]').forEach(function (el) { el.addEventListener('change', update); });

    bb.querySelectorAll('[data-tld-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, qty() + parseInt(btn.dataset.tldStep, 10));
        update();
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', update);

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        var items = [{ id: Number(idInput.value), quantity: qty() }];
        checkedAddons().forEach(function (el) { items.push({ id: Number(el.dataset.variant), quantity: 1 }); });
        atc.setAttribute('aria-busy', 'true');
        atc.disabled = true;
        addToCart(items).then(function () {
          atcLabel.textContent = atcLabel.dataset.added || 'Added to basket';
          afterAdd(mode);
        }).catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        }).then(function () {
          atc.removeAttribute('aria-busy');
          atc.disabled = !current.available;
          if (mode === 'stay') setTimeout(update, 1800);
        });
      });
    }

    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
      var sbtn = sticky.querySelector('[data-tld-sticky-atc]');
      if (sbtn) sbtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
      });
    }

    update();
  }

  function initToggle(t) {
    if (t.dataset.tldReady) return;
    t.dataset.tldReady = '1';
    var tabs = t.querySelectorAll('[data-tld-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var k = tab.dataset.tldTab;
        tabs.forEach(function (b) { var on = b === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        t.querySelectorAll('[data-tld-pane]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.tldPane === k); });
      });
    });
  }

  function initQuick(btn) {
    if (btn.dataset.tldReady) return;
    btn.dataset.tldReady = '1';
    btn.addEventListener('click', function () {
      var label = btn.textContent;
      btn.disabled = true;
      addToCart([{ id: Number(btn.dataset.variant), quantity: 1 }]).then(function () {
        btn.textContent = 'Added';
        afterAdd(btn.dataset.afterAdd);
      }).catch(function (err) {
        btn.textContent = err.message.length < 28 ? err.message : 'Unavailable';
      }).then(function () {
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-tld-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-tld-buybox]').forEach(initBuybox);
    scope.querySelectorAll('[data-tld-toggle]').forEach(initToggle);
    scope.querySelectorAll('[data-tld-quick]').forEach(initQuick);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.tlDepotInit = init;
})();
